import React, { useEffect } from 'react';
import { Collapse, IconButton, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import OverFlowTooltipWithCustomCss from '@/component/common/OverFlowTooltipWithCustomCss';
import MoreActionListOrg from './MoreActionListOrg';
import { handleClickShareStatus } from '../ListOrganizationHandler';
import Utils from '@/common/utils/utils';
import { getOrgStatus } from '../EditOrganizationHandler';
import Constant from '@/common/constant/Constant';
import "../css/CollapseListOrg.css";

export default function CollapseListOrg({
    org,
    customStyle,
    moreAction,
    setMoreAction,
    onClickUnlockOrg,
    onClickBlockOrg,
    onClickDeleteOrg,
    openShareStatusPopover,
    setOpenShareStatusPopover,
    openGroupPartnerOrSp,
    addNewTab
}) {
    return (
        <Collapse
            in={openGroupPartnerOrSp == org.id}
            timeout="auto"
            unmountOnExit
            className="setting-item setting-item-group border-bottom list-org-collapse"
        >
            <Table
                size="small"
                data-cy="system-user-list-table"
                style={{ borderCollapse: 'separate', borderSpacing: 0 }}
            >
                <TableBody>
                    {org.groupPartnerOrSp &&
                        !Utils.isEmptyArray(org.groupPartnerOrSp) &&
                        org.groupPartnerOrSp?.map(orgItem => (
                            <TableRow
                                className="setting-children-item-org-list collapse-invited"
                                key={orgItem.id}
                                style={{
                                    padding: 0,
                                    paddingLeft: '44px',
                                    justifyContent: 'flex-start',
                                    maxHeight: '36px'
                                }}
                            >
                                <TableCell style={{ borderBottom: 'none', paddingLeft: 44 }}>
                                    <div className="table--column-org-logo">
                                        <div className="fixed-with-logo">
                                            <img
                                                className="img-list-org-logo"
                                                src={orgItem.corporationLogo}
                                                alt=""
                                            />
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none' }}>
                                    <div className="list-org-name">
                                        <div className="org-name">
                                            <OverFlowTooltipWithCustomCss
                                                value={Utils.getTextByLanguage(
                                                    Constant.LANGUAGE_TYPE.JP,
                                                    orgItem.name
                                                )}
                                                onClick={e => {
                                                    addNewTab(
                                                        orgItem.id,
                                                        Utils.getTextByLanguage(
                                                            Constant.LANGUAGE_TYPE.JP,
                                                            orgItem.name
                                                        )
                                                    );
                                                }}
                                                style={{...customStyle, width: '130px'}}
                                                className='list-org-name-invited'
                                            />
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell style={{ borderBottom: 'none' }} className='user-status-invited'>
                                    <div
                                        className={`user-status user-status-${getOrgStatus(
                                            orgItem
                                        ).toLowerCase()}`}
                                    >
                                        {getOrgStatus(orgItem)}
                                    </div>
                                </TableCell>
                                <TableCell className='text-center btn-toggle-root' style={{ borderBottom: 'none' }}>
                                    <div className="switch-check hidden" style={{ paddingLeft: '20px' }}>
                                        <input
                                            type="checkbox"
                                            id="rootFlag"
                                            readOnly
                                        />
                                        <label>
                                            <span className="switch-text"></span>
                                        </label>
                                    </div>
                                </TableCell>
                                <TableCell
                                    style={{
                                        borderBottom: 'none',
                                        padding: '8px 20px',
                                    }}
                                >
                                    <IconButton
                                        onClick={e =>
                                            handleClickShareStatus(
                                                e,
                                                orgItem,
                                                setMoreAction,
                                                setOpenShareStatusPopover
                                            )
                                        }
                                    >
                                        <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                                    </IconButton>
                                    <MoreActionListOrg
                                        org={orgItem}
                                        moreAction={moreAction}
                                        setMoreAction={setMoreAction}
                                        onClickUnlockOrg={onClickUnlockOrg}
                                        onClickBlockOrg={onClickBlockOrg}
                                        onClickDeleteOrg={onClickDeleteOrg}
                                        popoverId={orgItem.id}
                                        openShareStatusPopover={openShareStatusPopover}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                </TableBody>
            </Table>
        </Collapse>
    );
}
